import { client } from './apiClient';

function getGaAccessToken() {
  return client(`google/accessToken`);
}

export { getGaAccessToken };
